const messages = {
    fr: {
      suivant: 'Suivant',
      valider: 'Valider',
      champ_obligatoire: 'Champs obligatoires',
      precedent: 'Précédent',
      merci_renseigner_adresse: 'Merci de renseigner votre adresse, ou cliquer sur "Je ne trouve pas mon adresse"',
      votre_adresse: 'Votre Adresse *',
      changez_votre_adresse: 'Modifiez votre adresse',
      N_rue: 'N°, rue',
      compl_addresse: "Complément d'adresse",
      ville: "Ville",
      code_postal: "Code postal",
      Madame: 'Madame',
      Numero_identification: 'Siren ou numéro DUNS *',
      Monsieur: 'Monsieur',
      'Corrigez les erreurs': 'Veuillez vérifier les erreurs restantes dans le formulaire.',
      trouvepasadresse: 'Vous ne trouvez pas votre adresse ?',
      trouvepasreparateur: 'Vous ne trouvez pas votre réparateur?',
      email_reparateur:'Email de votre réparateur *',
      enseigne_psa: 'Nom de la société *',
      VeeValidate: {
        attributes: {
            email: 'adresse mail',
            email_confirmation: 'confirmation de l\'adresse mail',
            full_name: 'nom complet',
            first_name: 'prénom',
            last_name: 'nom de famille',
            postcode: 'code postal',
            birthdate: 'date de naissance',
            buying_date: 'date d\'achat',
            date_max_today:'date',
            date_input:'date',
            phone: 'numéro de téléphone',
            mobile_phone: 'numéro de mobile',
            fixed_phone: 'numéro de téléphone fixe'
        },
        custom: {
            birthdate: {
                before: 'Vous devez être majeur'
            },
            ean: {
              regex: 'Votre code-barres doit comporter 13 chiffres'
            },
            siret: {
              regex: 'Le SIRET doit être composé de 14 chiffres'
            },
            email: {
              unique: 'Cette adresse email est déjà enregistrée. Cette opération est limitée à une seule participation par foyer',
            },
            siren: {
              regex: 'Le SIREN doit être composé de 9 chiffres'
            },
            confirm: {
              required:'Ce champ est obligatoire'
            },
            marketing1: {
              required:'Ce champ est obligatoire'
            },
            marketing2: {
              required:'Ce champ est obligatoire'
            },
            date_max_today: {
            date_min:"Cette date ne peut être antérieure au début de l'opération",
            required:'Ce champ est obligatoire'
          }
        }
      }
    },
    uk: {
      suivant: 'Next',
      valider: 'Submit',
      champ_obligatoire: 'Required fields',
      precedent: 'Previous',
      merci_renseigner_adresse: 'Please select a suggested address or click on "I can\'t find my address"',
      trouvepasadresse: 'I can\'t find my address',
      trouvepasreparateur: 'You can\'t find it?',
      email_reparateur:'E-mail of your repairer *',
      enseigne_psa: 'Company name *',
      Numero_identification: 'DUNS number *',
      votre_adresse: 'Your address *',
      changez_votre_adresse: 'Edit your address',
      N_rue: 'Number and street name *',
      compl_addresse: "Additional address info",
      ville: "City *",
      code_postal: "ZIP code *",
      Madame: 'Mrs.',
      Monsieur: 'Mr.',
      VeeValidate: {
        attributes: {
            email: 'e-mail',
            email_confirmation: 'confirm your e-mail',
            full_name: 'first and last name',
            first_name: 'first name',
            last_name: 'last name ',
            postcode: 'ZIP code',
            birthdate: 'birthdate',
            buying_date: 'buying date',
            date_max_today:'date',
            date_input:'date',
            phone: 'phone number',
            mobile_phone: 'mobile phone number',
            fixed_phone: 'landline phone number '
        },
        custom: {
            birthdate: {
                before: 'You must be of legal age'
            },
            date_max_today: {
              date_min:"This date can't be anterior to the start of this promotion"
            }
        }
      }
    },
    "es-es": {
      suivant: 'próximo',
      valider: 'Validar',
      champ_obligatoire: 'campos obligatorios',
      precedent: 'anterior',
      merci_renseigner_adresse: 'TO_TRANSLATE_ES Merci de renseigner votre adresse, ou cliquer sur "Je ne trouve pas mon adresse"',
      votre_adresse: 'Tu dirección *',
      changez_votre_adresse: 'Cambie tu dirección',
      Numero_identification: 'TO_TRANSLATE_ES D.U.N.S number *',
      N_rue: 'Número y nombre de la calle *',
      compl_addresse: "Información de dirección adicional",
      ville: "Ciudad *",
      code_postal: "Código postal",
      Madame: 'Señor',
      Monsieur: 'Señora',
      trouvepasreparateur: 'TO_TRANSLATE_ES_REPARATOR?',
      enseigne_psa: 'TO_TRANSLATE_ES_ENSEIGNE',
      email_reparateur:'TO_TRANSLATE_ES_E-mail of your repairer *',
      VeeValidate: {
        attributes: {
            email: 'Correo electrónico',
            email_confirmation: 'TO_TRANSLATE_ES confirmation de l\'adresse mail',
            full_name: 'TO_TRANSLATE_ES nom complet',
            first_name: 'Nombre',
            last_name: 'Apellido/s',
            postcode: 'Código postal',
            birthdate: 'TO_TRANSLATE_ES date de naissance',
            buying_date: 'TO_TRANSLATE_ES date d\'achat',
            date_max_today:'date',
            date_input:'date',
            phone: 'TO_TRANSLATE_ES numéro de téléphone',
            mobile_phone: 'TO_TRANSLATE_ES numéro de mobile',
            fixed_phone: 'TO_TRANSLATE_ES numéro de téléphone fixe'
        },
        custom: {
            birthdate: {
                before: 'TO_TRANSLATE_ES Vous devez être majeur'
            },
            date_max_today: {
              date_min:"TO_TRANSLATE_ES_This date can't be anterior to the start of this promotion"
            }
        }
      }
    },
    "es-cat": {
      suivant: 'Próximo',
      valider: 'ubmitos',
      champ_obligatoire: 'TO_TRANSLATE_ES CHAMPOS OBLIGANDO',
      precedent: 'TO_TRANSLATE_ES PRECEDENTOS',
      merci_renseigner_adresse: 'TO_TRANSLATE_ES Merci de renseigner votre adresse, ou cliquer sur "Je ne trouve pas mon adresse"',
      votre_adresse: 'Adreça *',
      N_rue: 'Carrer i número de casa *',
      compl_addresse: "Informació addicional sobre l'adreça",
      ville: "TO_TRANSLATE_ES Ville",
      code_postal: "TO_TRANSLATE_ES Code postal",
      Numero_identification: 'TO_TRANSLATE_ES_D.U.N.S number *',
      Madame: 'TO_TRANSLATE_ES Madame',
      Monsieur: 'TO_TRANSLATE_ES Monsieur',
      trouvepasreparateur: 'TO_TRANSLATE_CAT_REPARATOR?',
      email_reparateur:'TO_TRANSLATE_CAT_E-mail of your repairer *',
      enseigne_psa: 'TO_TRANSLATE_CAT_ENSEIGNE',
      VeeValidate: {
        attributes: {
            email: 'TO_TRANSLATE_ES adresse mail',
            email_confirmation: 'TO_TRANSLATE_ES confirmation de l\'adresse mail',
            full_name: 'TO_TRANSLATE_ES nom complet',
            first_name: 'TO_TRANSLATE_ES prénom',
            last_name: 'TO_TRANSLATE_ES nom de famille',
            postcode: 'TO_TRANSLATE_ES code postal',
            birthdate: 'TO_TRANSLATE_ES date de naissance',
            buying_date: 'TO_TRANSLATE_ES date d\'achat',
            date_max_today:'date',
            date_input:'date',
            phone: 'TO_TRANSLATE_ES numéro de téléphone',
            mobile_phone: 'TO_TRANSLATE_ES numéro de mobile',
            fixed_phone: 'TO_TRANSLATE_ES numéro de téléphone fixe'
        },
        custom: {
            birthdate: {
                before: 'TO_TRANSLATE_ES Vous devez être majeur'
            },
            date_max_today: {
              date_min:"TO_TRANSLATE_CAT_This date can't be anterior to the start of this promotion"
            }
        }
      }
    },
    de: {
      suivant: 'Weiter',
      valider: 'validate',
      champ_obligatoire: 'Pflichtangabe',
      precedent: 'zurück',
      merci_renseigner_adresse: 'Bitte geben Sie Ihre Adresse ein, oder klicken Sie auf "Ich kann meine Adresse nicht finden".',
      votre_adresse: 'Ihre Adresse *',
      N_rue: 'Strasse und Hausnummer *',
      compl_addresse: "Adresszusatz",
      Numero_identification: 'D.U.N.S nummer *',
      ville: "Ort *",
      code_postal: "Postleitzahl *",
      Madame: 'Frau',
      Monsieur: 'Herr',
      trouvepasadresse: ' Sie finden Ihre Adresse nicht?',
      trouvepasreparateur: 'Sie finden Ihre reparatur nicht?',
      email_reparateur:'E-Mail Adresse *',
      enseigne_psa: 'Firmenamme *',
      VeeValidate: {
        attributes: {
            email: 'E-mail',
            email_confirmation: 'Bestätigen Sie Ihre E-Mail',
            full_name: 'Name und Vorname',
            first_name: 'Vorname',
            last_name: 'Nachname',
            postcode: 'Postleitzahl',
            birthdate: 'Geburtstag',
            buying_date: 'Kaufdatum',
            date_max_today:'Datum',
            date_input:'Datum',
            phone: 'Telefonnummer',
            mobile_phone: 'Handynummer',
            fixed_phone: 'Festnetznummer'
        },
        custom: {
            birthdate: {
                before: 'Sie müssen volljährig sein'
            },
            date_max_today: {
              date_min:"Dieses Datum darf nicht vor dem Start dieses Vorgangs liegen."
            }
        }
      }
    },
    nl: {
      suivant: 'volgend',
      valider: 'bevestigen',
      champ_obligatoire: 'verplichte velden',
      precedent: 'vorig',
      merci_renseigner_adresse: 'Voer alstublieft uw adres in, of klik op "Ik kan mijn adres niet vinden"',
      votre_adresse: 'Uw adres *',
      N_rue: 'Straatnaam en huisnummer *',
      compl_addresse: "Aanvullende adresinformatie",
      ville: "Stad *",
      code_postal: "Postcode *",
      Madame: 'Mevr',
      Monsieur: 'Man',
      Numero_identification: 'D.U.N.S nummer *',
      trouvepasadresse: 'Staat uw adres er niet bij?',
      trouvepasreparateur: 'Ik kan mijn reparateur niet vinden?',
      email_reparateur:'Reparateur email *',
      enseigne_psa: 'bedrijfsnaam *',
      VeeValidate: {
        attributes: {
            email: 'Email',
            email_confirmation: 'Bevestig je email',
            full_name: 'Voor- en achternaam',
            first_name: 'Voornaam',
            last_name: 'Achternaam',
            postcode: 'Postcode',
            birthdate: 'Geboortedatum',
            buying_date: 'Aankoopdatum',
            date_max_today:'Datum',
            date_input:'Datum',
            phone: 'Telefoonnummer',
            mobile_phone: 'Mobiele telefoonnummer',
            fixed_phone: 'Vast telefoonnummer'
        },
        custom: {
            birthdate: {
                before: 'Je moet de wettelijke leeftijd hebben'
            },
            date_max_today: {
              date_min:"Dieses Datum darf nicht vor dem Start dieses Vorgangs liegen."
            }
        }
      }
    },
    "lu-fr": {
      suivant: 'Suivant',
      valider: 'Valider',
      champ_obligatoire: 'Champ obligatoire',
      precedent: 'Précédent',
      merci_renseigner_adresse: 'Merci de renseigner votre adresse, ou cliquer sur "Je ne trouve pas mon adresse"',
      votre_adresse: 'Votre Adresse *',
      N_rue: 'N°, rue *',
      compl_addresse: "Complément d'adresse",
      ville: "Ville *",
      Numero_identification: 'Numéro D.U.N.S *',
      code_postal: "Code postal *",
      Madame: 'Madame',
      Monsieur: 'Monsieur',
      trouvepasadresse: 'Vous ne trouvez pas votre adresse ?',
      email_reparateur:'email de votre réparateur *',
      enseigne_psa: 'Nom de la société *',
      VeeValidate: {
        attributes: {
            email: 'adresse mail',
            email_confirmation: 'confirmation de l\'adresse mail',
            full_name: 'nom complet',
            first_name: 'prénom',
            last_name: 'nom de famille',
            postcode: 'code postal',
            birthdate: 'date de naissance',
            buying_date: 'date d\'achat',
            date_max_today:'date',
            date_input:'date',
            phone: 'numéro de téléphone',
            mobile_phone: 'numéro de mobile',
            fixed_phone: 'numéro de téléphone fixe'
        },
        custom: {
            birthdate: {
                before: 'Vous devez être majeur'
            },
            date_max_today: {
              date_min:"Cette date ne peut être antérieure au début de l'opération",
              required:'Ce champ est obligatoire'
            }
        }
      }
    },
    "lu-nl": {
      suivant: 'volgend',
      valider: 'bevestigen',
      champ_obligatoire: 'verplichte velden',
      precedent: 'vorig',
      merci_renseigner_adresse: 'Voer alstublieft uw adres in, of klik op "Ik kan mijn adres niet vinden"',
      votre_adresse: 'Jouw adres *',
      N_rue: 'Straat en huisnummer *',
      compl_addresse: "Aanvullende adresgegevens",
      ville: "Stad *",
      code_postal: "Postcode *",
      Madame: 'Mevr',
      Monsieur: 'Man',
      Numero_identification: 'D.U.N.S nummer *',
      trouvepasadresse: 'Vind je je adres niet ?',
      trouvepasreparateur: 'Ik kan mijn reparateur niet vinden?',
      email_reparateur:'Reparateur e-mail*',
      enseigne_psa: 'bedrijfsnaam *',
      VeeValidate: {
        attributes: {
            email: 'Email',
            email_confirmation: 'Bevestig je email',
            full_name: 'Voor- en achternaam',
            first_name: 'Voornaam',
            last_name: 'Achternaam',
            postcode: 'Postcode',
            birthdate: 'Geboortedatum',
            buying_date: 'Aankoopdatum',
            date_max_today:'Datum',
            date_input:'Datum',
            phone: 'Telefoonnummer',
            mobile_phone: 'Mobiele telefoonnummer',
            fixed_phone: 'Vast telefoonnummer'
        },
        custom: {
            birthdate: {
                before: 'Je moet de wettelijke leeftijd hebben'
            },
            date_max_today: {
              date_min:"Deze datum kan niet vroeger zijn dan de start van deze bewerking"
            }

        }
      }
    },
    "be-fr": {
      suivant: 'Suivant',
      valider: 'Valider',
      champ_obligatoire: 'Champ obligatoire',
      precedent: 'Précédent',
      merci_renseigner_adresse: 'Merci de renseigner votre adresse, ou cliquer sur "Je ne trouve pas mon adresse"',
      votre_adresse: 'Votre Adresse *',
      N_rue: 'N°, rue *',
      compl_addresse: "Complément d'adresse",
      ville: "Ville *",
      code_postal: "Code postal *",
      Madame: 'Madame',
      Monsieur: 'Monsieur',
      trouvepasadresse: 'Vous ne trouvez pas votre adresse ?',
      enseigne_psa: 'Nom de la société * ',
      Numero_identification: 'numéro DUNS *',
      email_reparateur:'Email de votre réparateur *',
      VeeValidate: {
        attributes: {
            email: 'adresse mail',
            email_confirmation: 'confirmation de l\'adresse mail',
            full_name: 'nom complet',
            first_name: 'prénom',
            last_name: 'nom de famille',
            postcode: 'code postal',
            birthdate: 'date de naissance',
            buying_date: 'date d\'achat',
            date_max_today:'date',
            date_input:'date',
            phone: 'numéro de téléphone',
            mobile_phone: 'numéro de mobile',
            fixed_phone: 'numéro de téléphone fixe'
        },
        custom: {
            birthdate: {
                before: 'Vous devez être majeur'
            },
            date_max_today: {
              date_min:"Cette date ne peut être antérieure au début de l'opération",
              required:'Ce champ est obligatoire'
            }
        }
      }
    },
    "be-nl": {
      suivant: 'volgend',
      valider: 'bevestigen',
      champ_obligatoire: 'verplichte velden',
      precedent: 'vorig',
      merci_renseigner_adresse: 'Voer alstublieft uw adres in, of klik op "Ik kan mijn adres niet vinden"',
      votre_adresse: 'Jouw adres *',
      N_rue: 'Straat en huisnummer *',
      compl_addresse: "Aanvullende adresgegevens",
      trouvepasreparateur: 'Ik kan mijn reparateur niet vinden?',
      enseigne_psa: 'bedrijfsnaam *',
      ville: "Plaats *",
      code_postal: "Postcode *",
      Numero_identification: 'D.U.N.S nummer *',
      Madame: 'Mevr',
      Monsieur: 'Man',
      trouvepasadresse: 'Vind je je adres niet ?',
      email_reparateur:'Reparateur e-mail*',
      VeeValidate: {
        attributes: {
            email: 'E-mail',
            email_confirmation: 'Bevestig je email',
            full_name: 'Voor- en achternaam',
            first_name: 'Voornaam',
            last_name: 'Naam',
            postcode: 'Postcode',
            birthdate: 'Geboortedatum',
            buying_date: 'Aankoopdatum',
            date_max_today:'Datum',
            date_input:'Datum',
            phone: 'Telefoon',
            mobile_phone: 'Mobiele telefoon',
            fixed_phone: 'Vast telefoon'
        },
        custom: {
            birthdate: {
                before: 'Je moet de wettelijke leeftijd hebben'
            },
            date_max_today: {
              date_min:"Deze datum kan niet vroeger zijn dan de start van deze bewerking",
            }
        }
      }
    },
    it: {
      suivant: 'TO_TRANSLATE_IT Suivant',
      valider: 'TO_TRANSLATE_IT Valider',
      champ_obligatoire: 'TO_TRANSLATE_IT Champ obligatoire',
      precedent: 'TO_TRANSLATE_IT Précédent',
      merci_renseigner_adresse: 'TO_TRANSLATE_IT Merci de renseigner votre adresse, ou cliquer sur "Je ne trouve pas mon adresse"',
      votre_adresse: 'TO_TRANSLATE_IT Votre Adresse',
      N_rue: 'N°, rue *',
      compl_addresse: "Complément d'adresse",
      ville: "Ville *",
      code_postal: "Code postal *",
      Madame: 'Madame',
      Monsieur: 'Monsieur',
      Numero_identification: 'TO_TRANSLATE_IT_D.U.N.S nummer *',
      trouvepasadresse: 'Vous ne trouvez pas votre adresse ?',
      trouvepasreparateur: 'TO_TRANSLATE_IT_REPARATOR?',
      enseigne_psa: 'TO_TRANSLATE_IT_ENSEIGNE',
      email_reparateur:'TO_TRANSLATE_IT_Email de votre réparateur *',
      VeeValidate: {
        attributes: {
            email: 'adresse mail',
            email_confirmation: 'confirmation de l\'adresse mail',
            full_name: 'nom complet',
            first_name: 'prénom',
            last_name: 'nom de famille',
            postcode: 'code postal',
            birthdate: 'date de naissance',
            buying_date: 'date d\'achat',
            date_max_today:'date',
            date_input:'date',
            phone: 'numéro de téléphone',
            mobile_phone: 'numéro de mobile',
            fixed_phone: 'numéro de téléphone fixe'
        },
        custom: {
            birthdate: {
                before: 'Vous devez être majeur'
            },
            date_max_today: {
              date_min:"TO_TRANSLATE_IT_Deze datum kan niet vroeger zijn dan de start van deze bewerking",
            }
        }
      }
    },
    pl: {
      suivant: 'TO_TRANSLATE_PL NECHT',
      valider: 'TO_TRANSLATE_PL SUBMICHT',
      champ_obligatoire: 'TO_TRANSLATE_PL NECHT FIELTCHHH',
      precedent: 'TO_TRANSLATE_PL BACHT',
      merci_renseigner_adresse: 'TO_TRANSLATE_PL Merci de renseigner votre adresse, ou cliquer sur "Je ne trouve pas mon adresse"',
      votre_adresse: 'TO_TRANSLATE Your address',
      N_rue: 'TO_TRANSLATE_PL N°, rue',
      compl_addresse: "TO_TRANSLATE_PL Complément d'adresse",
      Numero_identification: 'TO_TRANSLATE_PL_D.U.N.S nummer',
      ville: "TO_TRANSLATE_PL Ville",
      code_postal: "TO_TRANSLATE_PL Code postal",
      Madame: 'TO_TRANSLATE_PL Madame',
      Monsieur: 'TO_TRANSLATE_PL Monsieur',
      trouvepasreparateur: 'TO_TRANSLATE_PL_REPARATOR?',
      email_reparateur:'TO_TRANSLATE_PL_Email de votre réparateur *',
      enseigne_psa: 'TO_TRANSLATE_PL_ENSEIGNE',
      VeeValidate: {
        attributes: {
            email: 'TO_TRANSLATE_PL adresse mail',
            email_confirmation: 'TO_TRANSLATE_PL confirmation de l\'adresse mail',
            full_name: 'TO_TRANSLATE_PL nom complet',
            first_name: 'TO_TRANSLATE_PL prénom',
            last_name: 'TO_TRANSLATE_PL nom de famille',
            postcode: 'TO_TRANSLATE_PL code postal',
            birthdate: 'TO_TRANSLATE_PL date de naissance',
            buying_date: 'TO_TRANSLATE_PL date d\'achat',
            date_max_today:'date',
            date_input:'date',
            phone: 'TO_TRANSLATE_PL numéro de téléphone',
            mobile_phone: 'TO_TRANSLATE_PL numéro de mobile',
            fixed_phone: 'TO_TRANSLATE_PL numéro de téléphone fixe'
        },
        custom: {
            birthdate: {
                before: 'TO_TRANSLATE_PL Vous devez être majeur'
            },
            date_max_today: {
              date_min:"TO_TRANSLATE_PL_Deze datum kan niet vroeger zijn dan de start van deze bewerking",
            }
        }
      }
    },
  }

messages['es'] = messages['es-es']
messages['en-uk'] =  messages['uk']
messages['en'] =  messages['uk']
messages['fr-fr'] =  messages['fr']

export default {
    mixin: {
        methods: {
            $t(key, locale) {
                if(messages[locale] && messages[locale][key]) {
                  return messages[locale][key];
                } else if(messages['fr'] && messages['fr'][key]){
                  return messages['fr'][key];
                } else {
                  return key;
                }
            },
        }
    },
    ...messages
};